import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	Renderer2,
	SecurityContext,
	ViewChild,
} from '@angular/core';
import { DropdownItem } from '../../../models/dropdown-item.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'netfirm-login-footer',
	templateUrl: './netfirm-footer.component.html',
	styleUrls: ['./netfirm-footer.component.scss'],
})
export class NetfirmFooterComponent {
	@Input() public footerText!: string;
	@Input() public selectButtonOptions!: DropdownItem[];
	@Input() public selectedOption!: DropdownItem;
	@Input() public enableSelectButton = false;
	@Output() public selectButtonChange = new EventEmitter<string>();
	@ViewChild('dropdownMenu') public dropdownMenu!: ElementRef;

	public isDropdownOpen = false;
	public documentClickListener!: () => void;
	public year = new Date().getFullYear();

	public constructor(private readonly sanitizer: DomSanitizer, private readonly renderer: Renderer2) {}

	public onSelectChange($event: Event): void {
		const value = this.sanitizer.sanitize(SecurityContext.HTML, ($event.target as HTMLSelectElement).value);
		this.selectButtonChange.emit(value ?? '');
	}

	public toggleDropdown(): void {
		this.isDropdownOpen = !this.isDropdownOpen;

		if (this.isDropdownOpen) {
			setTimeout(() => {
				this.documentClickListener = this.renderer.listen('document', 'click', event => {
					if (!this.dropdownMenu.nativeElement.contains(event.target)) {
						this.toggleDropdown();
					}
				});
			}, 0);
		} else {
			// Unlisten renderer event
			this.documentClickListener();
		}
	}

	public selectOption(option: DropdownItem): void {
		this.selectedOption = option;
		this.selectButtonChange.emit(option.value);
		this.toggleDropdown();
	}

	public onKeydown(event: KeyboardEvent, index?: number): void {
		if (!this.isDropdownOpen) {
			return;
		}

		const currentIndex = index ?? 0;

		const menuItems = this.dropdownMenu.nativeElement.children;

		if (event.key === 'ArrowUp') {
			event.preventDefault();
			if (currentIndex > 0) {
				menuItems[currentIndex - 1].focus();
			} else {
				menuItems[menuItems.length - 1].focus();
			}
		} else if (event.key === 'ArrowDown' || event.key === 'Tab') {
			event.preventDefault();
			if (currentIndex < menuItems.length - 1) {
				menuItems[currentIndex + 1].focus();
			} else {
				menuItems[0].focus();
			}
		} else if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.selectOption(this.selectButtonOptions[index ?? 0]);
		} else if (event.key === 'Escape') {
			event.preventDefault();
			this.toggleDropdown();
		}
	}
}
